export const verification = {
  title: 'views-reset-pwd-email-title',
  desc: 'views-reset-pwd-verif-desc',
  descAgain: 'views-reset-pwd-verif-descAgain',
  formWidth: '53%',
  tryAgainBtn: {
    title: 'try-again-2',
    show: true,
  },
  formItems: [
    {
      field: 'verificationCode',
      type: 'text',
      label: 'views-reset-pwd-verif-subtit',
      errorMsg: '',
      contentInputGroupMarginTop: '8px',
    },
  ],
};
